import React, { useState } from 'react';
import { StubLabel } from 'Components/Texts';
import { passStrength } from 'Utils/FormValidation';

export const PasswordField = ({
  label,
  autofocus,
  ariaLabel,
  autoComplete,
  name,
  warn,
  value = '',
  error,
  handleChange,
  onBlur,
  touched,
  className = '',
  isDisabled = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const warning = warn && passStrength(value);

  let inputClassName = touched && error ? 'formFieldInput inputError' : 'formFieldInput';
  inputClassName = value || isDisabled ? `${inputClassName} hasValue` : inputClassName;
  const meterClass = `meter ${warning}`;
  const inputType = showPassword ? 'text' : 'password';
  const showPasswordIconClass = showPassword ? 'showPasswordIcon active' : 'showPasswordIcon';
  const showPasswordIconLabel = showPassword ? 'Hide Password' : 'Show Password';

  const labelId = label && !ariaLabel ? `password-input-${label.replace(/\s+/g, '')}` : null;

  //onDragStart, onDrop, onFocus?

  return (
    <div className={`formField animatedFieldContainer ${className}`}>
      <div className="passwordInput">
        <input
          className={inputClassName}
          onChange={handleChange}
          onBlur={onBlur}
          value={value}
          name={name}
          type={inputType}
          autoFocus={autofocus}
          disabled={isDisabled}
          autoComplete={autoComplete || 'off'}
          aria-label={ariaLabel}
          aria-labelledby={labelId}
        />
        {label && <StubLabel text={label} id={labelId} className="animatedLabel" />}
        <div className="showPasswordIconLabel">
          <span
            className={showPasswordIconClass}
            aria-label={showPasswordIconLabel}
            role="button"
            onClick={toggleShowPassword}
          />
        </div>
      </div>
      {(touched && error && <span className="formFieldError">{error}</span>) ||
        (warning && (
          <div className="passwordStrength">
            <span className={meterClass}>
              <span className="activeMeter" />
            </span>
            <span className="text">{warning}</span>
          </div>
        ))}
    </div>
  );
};
